module.exports = {"210703001":"正大街道","210703002":"石桥子街道","210703003":"龙江街道","210703004":"榴花街道","210703005":"铁新街道","210703006":"凌安街道","210703007":"菊园街道","210703008":"康宁街道","210703009":"锦铁街道","210703010":"马家洼子街道","210703011":"紫荆街道","210703403":"锦州北山农工商总公司"}


//////////////////
// WEBPACK FOOTER
// ./src/town/210703.json
// module id = 552
// module chunks = 0